"use client";
import { useEffect, useState } from "react";
import { MappedProject } from "../types/new/project";
import { groupProjectsByYear } from "../utils/project-utils";
import { useSearchParams } from "next/navigation";

export default function useFilterProjects(allProjects?: MappedProject[]) {
  const searchParams = useSearchParams();
  const [allYears, setAllYears] = useState<string[]>([]);
  const [projectsByYear, setProjectsByYear] = useState<
    Record<string, MappedProject[]>
  >({});
  const [projects, setProjects] = useState<MappedProject[]>([]);

  useEffect(() => {
    if (!allProjects) {
      setProjectsByYear({});
      setProjects([]);
      return;
    }

    if (searchParams.has("architecture")) {
      const architecturalProjects = allProjects.filter((p) =>
        p.architectureThemes?.find(
          (t) => t.slug === searchParams.get("architecture")
        )
      );
      setProjectsByYear(groupProjectsByYear(architecturalProjects));
      setProjects(architecturalProjects);
    } else if (searchParams.has("ecosysteme")) {
      const ecosystemicProjects = allProjects.filter((p) =>
        p.ecosystemeThemes.find(
          (t) => t.slug === searchParams.get("ecosysteme")
        )
      );
      setProjectsByYear(groupProjectsByYear(ecosystemicProjects));
      setProjects(ecosystemicProjects);
    } else {
      setProjectsByYear(groupProjectsByYear(allProjects));
      setProjects(allProjects);
    }
  }, [searchParams, allProjects]);

  useEffect(() => {
    setAllYears(Object.keys(projectsByYear).sort((a, b) => b.localeCompare(a)));
  }, [projectsByYear]);

  return { allYears, projectsByYear, filtredProjects: projects };
}
